import React from 'react';
import { Row, Col } from 'reactstrap';
import styles from './Partners.module.scss';
import './OverRide.scss';

const Partners = ({ isJoinPage = false }) => {
  return (
    <div
      className={`${styles.main_partners} ${
        isJoinPage ? 'mainpartnersOverride' : ''
      }`}
    >
      <Row>

        <Col sm={12} md={12}>
          <div className={`${styles.partners} ${isJoinPage ? "partnersOverride" : ""}`}>
            <div className={styles.head}>
              <h3>
                MutantApeBaseClub
              </h3>
            </div>
            
            {isJoinPage ? null : (
              <div className={styles.social_icons}>
                <img src='Assets/.png' alt='' />
                <a href="https://twitter.com/MutantApeBC_"><img src='Assets/.png' alt='' /></a>
              </div>
            )}
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default Partners;
